import { styled } from '@mui/material/styles'
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'

export const StyledTableCell = styled('td')(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14
  }
}))

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover ? theme.palette.action.hover : 'rgba(145, 158, 171, 0.08)'
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0
  }
}))

export const CenteredContainer = styled('div')({
  display: 'flex',
  height: '50vh',
  alignItems: 'center',
  justifyContent: 'center'
})
